import { render, staticRenderFns } from "./Joins.vue?vue&type=template&id=51cb3703"
import script from "./Joins.vue?vue&type=script&lang=js"
export * from "./Joins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51cb3703')) {
      api.createRecord('51cb3703', component.options)
    } else {
      api.reload('51cb3703', component.options)
    }
    module.hot.accept("./Joins.vue?vue&type=template&id=51cb3703", function () {
      api.rerender('51cb3703', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/schedule/Joins.vue"
export default component.exports